import styles from "./styles.module.scss";
import FirstImg from "../../assets/solutions/expertise/first.png";
import SecondImg from "../../assets/solutions/expertise/second.png";
import ThirdImg from "../../assets/solutions/expertise/third.png";
import FourthImg from "../../assets/solutions/expertise/four.png";
import FifthImg from "../../assets/solutions/expertise/five.png";
import SixthImg from "../../assets/solutions/expertise/six.png";

const Expertise = () => {
  const expertiseCards = [
    {
      title: "Hands-on labs for each cloud environment",
      imgSrc: FirstImg,
      description:
        "We have built hands-on labs for AWS, Azure, and GCP to provide our students with real-world simulations of organizations and the security controls they may implement to address cybersecurity risks.",
    },
    {
      title: "Registered CPEs to ensure compliance",
      imgSrc: SecondImg,
      description:
        "Our trainings are NASBA registered. This means that you can use Continuing Professional Education (CPE) credits from Train GRC to fulfill AICPA and other certification body requirements.",
    },
    {
      title: "Identify and explain real-world risks",
      imgSrc: ThirdImg,
      description:
        "We don’t just walk you through the configurations that are necessary to protect your organization; we talk about some of the common threats that enhance risk and the controls that may mitigate or compensate for them.",
    },
    {
      title: "State-of-the-art content production",
      imgSrc: FourthImg,
      description:
        "Train GRC has invested in cutting-edge capabilities for content production. These capabilities can be put to task for your custom training needs. We offer a full suite of custom training development services.",
    },
    {
      title: "Advisory services trusted by top companies",
      imgSrc: FifthImg,
      description:
        "Our consultants have assisted Fortune 500 clients in highly regulated industries, from energy companies to financial institutions.",
    },
    {
      title: "Tools for audit assistance",
      imgSrc: SixthImg,
      description:
        "Train GRC helps you learn the relevant techniques and gives you instant access to tools that can supercharge your cloud security audits.",
    },
  ];

  return (
    <section className={styles.expertise} aria-labelledby="expertise-heading">
      <div className={styles.expertiseInner}>
        <div className={styles.sectionHeading}>
          <p className={styles.eyebrow}>Why Train GRC</p>
          <h2 id="expertise-heading">
            Expertise <span>you can rely on.</span>
          </h2>
        </div>
        <div className={styles.expertiseGrid}>
          {expertiseCards.map((item) => (
            <article className={styles.expertiseCard} key={item.title}>
              <div className={styles.expertiseIcon} aria-hidden="true">
                <img src={item.imgSrc} alt="" />
              </div>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
export default Expertise;
